import * as React from 'react';
import { TooltipCommonProps } from '../common';

export interface FormFieldProps {
  children?:
    | React.ReactNode
    | ((data: { setCharactersLeft: CharactersLeftFn }) => React.ReactNode);
  charCount?: number;
  stretchContent?: boolean;
  label?: React.ReactNode;
  labelAlignment?: LabelAlignment;
  labelPlacement?: LabelPlacement;
  labelSize?: LabelSize;
  required?: boolean;
  infoContent?: React.ReactNode;
  infoTooltipProps?: TooltipCommonProps;
  suffix?: React.ReactNode;
  status?: StatusType;
  statusMessage?: React.ReactNode;
  id?: string;
  labelId?: string;
  dataHook?: string;
}

export default class FormField extends React.Component<FormFieldProps> {}

export type StatusType = 'error' | 'warning' | 'loading';
export type LabelPlacement = 'top' | 'right' | 'left';
export type LabelSize = 'tiny' | 'small';
export type LabelAlignment = 'middle' | 'top';
type CharactersLeftFn = (lengthLeft: number) => void;
